import { mediaBaseURL } from "../../Services";

// The API stores and returns a bare filename — `1787572085_438.webp` —
// because that is what the column holds. The image itself is served by the
// media host, which resizes it and reads the object out of R2.
//
// Note this is not `api.makemyhouse.com/public/Media/rimage/...`. That host
// only redirects to the same media server, so pointing straight at it drops
// a round trip.
const RESIZE_PATH = "rimage";
const FOLDER = "completed-project";

// PDFs are stored as the PDF plus a JPEG companion under etc/tt/, and that
// companion is what gets rendered.
const PDF_FOLDER = `${FOLDER}/etc/tt`;

export const IMAGE_SIZES = { thumb: 100, card: 500, full: 1024 };

/**
 * True for anything already renderable as-is: a local object URL from a file
 * the admin just picked, or a data URI from the mock. Only bare filenames
 * need turning into a media URL.
 */
const isRenderable = (value) => /^(blob:|data:|https?:\/\/)/i.test(String(value || ""));

/**
 * Builds the URL for one stored image.
 *
 * @param {string} fileName  bare filename as the API returned it
 * @param {number} size      1024 | 500 | 100 | 10; anything else serves the original
 */
export const buildImageUrl = (fileName, size = IMAGE_SIZES.card) => {
  if (!fileName) return "";
  if (isRenderable(fileName)) return fileName;

  const isPdf = String(fileName).toLowerCase().endsWith(".pdf");
  const folder = isPdf ? PDF_FOLDER : FOLDER;
  const name = isPdf ? String(fileName).replace(/\.pdf$/i, ".jpg") : fileName;

  return `${mediaBaseURL}${RESIZE_PATH}/${size}/${folder}/${encodeURIComponent(name)}`;
};

/**
 * Picks whatever an image record can be rendered from. The mock hands back a
 * data URI on `url`; the real API hands back `fileName`. Taking both means
 * flipping USE_MOCK never breaks the previews.
 */
export const imageSrcOf = (image, size = IMAGE_SIZES.card) => {
  if (!image) return "";
  if (isRenderable(image.url)) return image.url;
  return buildImageUrl(image.fileName || image.url, size);
};

export default buildImageUrl;
